import { ComponentStyleConfig } from "@chakra-ui/react";

const FieldsetTheme: ComponentStyleConfig = {
  baseStyle: {
    padding: 6,
    marginBottom: 4,
    borderWidth: "1px",
    borderColor: "gray.200",
  },
  variants: {
    solid: {
      px: "16px",
      pt: "10px",
      pb: "20px",
      legend: {
        px: "8px",
      },
    },
    dashed: {
      background: "gray.50",
      borderStyle: "dashed",
      borderRadius: "8px",
    },
    overline: {
      bg: "gray.50",
      background: "gray.50",
      borderRadius: "4px",
      padding: "8px",
      legend: {
        float: "left",
        textColor: "gray.400",
        textStyle: "overline",
      },
    },
  },
  defaultProps: {
    variant: "dashed",
    borderRadius: "2px",
  },
};

export default FieldsetTheme;
